import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper';
import './styles.css'

const ItemPicking = (props) => {
    /**
     * nombre : titulo del item
     * descripcion: sub titulo, una linea
     * fecha: seguna linea de sub titulo, timestamp
     * monto: cantidad a la derecha, formateada como moneda
     * opciones: lista de opciones desplegables {nombre: string, handler: func}
     * onClick: click en cualquier lugar del item
     */
        return <div onClick={props.onClick} className='containerItemSubrubroPicking'>
                    <div className='imgNombre'>
                        <img src={props.item.imagen ? props.item.imagen : require('./../../images/default_subrubro.png')}  onDragStart={(e)=>{e.preventDefault();}} alt=""/>
                            
                        <div>
                            <div className="nombreSubrubro">{props.item.nombre}</div>
                            <div className="nombreRubro">{props.item.nombreRubro}</div>
                        </div>
                    </div>
                </div>
    }

class Picking extends React.Component {

    over=null;

    dragStart(e) {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', this.dragged);
    }
      
    dragEnd(e) {
        // update state
        var from = Number(this.dragged.dataset.id);
        var to = Number(this.over);
        if (from!==to && to!==-1){
            this.props.handleOnSwap(from, to)
        }
    }

    dragOver(e) {
        e.preventDefault();
        if(e.target.className === 'placeholder') return;
        if(e.target.dataset.id){
            this.over = e.target.dataset.id;
            e.target.style = e.target.style + "background-color:yellow;" 
        }        
    }

    render() {
        return (
            <div id="scrollItemsPicking" className="containerPicking" data-id={-1} onDragOver={this.dragOver.bind(this)}>

                {/* menú superior */}
                <TitleBar 
                    title={'Picking'} 
                />

                <div className="subtitulo">Orden de subrubros en góndola</div>

                <Paper  onDragOver={this.dragOver.bind(this)} style={{backgroundColor: "transparent", boxShadow:'none'}}>
                    <Row style={{margin: '0px'}}>
                        {this.props.subRubros.map && this.props.subRubros.map((x,i)=>
                            <Col 
                                md={6} lg={4}
                                className='draggable' 
                                data-id={x.idSubrubro} 
                                draggable='true' 
                                onDragEnd={this.dragEnd.bind(this)} 
                                onDragStart={this.dragStart.bind(this)}
                            >
                                <ItemPicking item={x}/>
                            </Col>
                        )}

                        {!this.props.loading && this.props.subRubros.length === 0 && 
                        <div className="labelNoResultados">No se encontraron resultados para ser mostrados.</div>}
                    </Row>
                </Paper>
            </div>
        )
    }
}

Picking.propTypes = {
    subRubros: PropTypes.array,
    handleOnSwap: PropTypes.func,
    loading: PropTypes.bool,
}

Picking.defaultProps = {
    subRubros: [],
    handleOnSwap: f => f,
    loading: false
}

export default Picking